import { defineComponent as _defineComponent } from 'vue'
import type { StreamingChartModuleFragment } from '@/features/onboarded-home/types';

import StreamingChartListItem from '@/features/onboarded-home/components/modules/streaming-chart/StreamingChartListItem.vue';
import { SnowplowContext } from '@/helpers/tracking/providers';

type StreamingChartList = StreamingChartModuleFragment['packagesWithTitles'][number]['titlesWithTrend'];


export default /*#__PURE__*/_defineComponent({
  __name: 'StreamingChartList',
  props: {
    titles: null,
    additionalContexts: { default: () => [] }
  },
  setup(__props: any) {



return { __sfc: true,StreamingChartListItem }
}

})